import { createFileRoute } from '@tanstack/react-router';

import { AdminAdsPage } from '@/components/admin/ads-page';
import { adminHead } from '@/lib/seo';
import { adminListAdsFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/ads')({
    component: AdsRoute,
    head: () => adminHead('מודעות', '/admin/ads'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListAdsFn({ data: { days: 7 } }),
});

function AdsRoute() {
    const data = Route.useLoaderData();
    return <AdminAdsPage initial={data} />;
}
